<template>
  <div v-if="!loading" class="layout" style="background-color: #f5f5f5">
    <van-tabs
      class="vantabs"
      v-model="active"
      animated
      swipeable
      color="#2E94E5"
      line-height="3px"
      title-active-color="#2E94E5"
    >
      <van-tab v-for="item in navData" :key="item.text" :title="item.text">
        <component
          v-if="item.show"
          :is="item.url"
          :list.sync="item.data"
          @show-dialog="showDialog"
        ></component>
      </van-tab>
    </van-tabs>
    <van-popup v-model="showSigns" closeable :style="{ height: '80%' }">
      <div class="sign-middle">
        <img src="http://img.xiaoqijiankang.com/images/signs.jpg" />
      </div>
    </van-popup>
    <BottomNav v-if="showNav == 1" />
  </div>
</template>
<script>
import Organ from "@/components/Organ"
import Summary from "@/components/Summary"
import Physiology from "@/components/Physiology"
import Brain from "@/components/Brain"
import Diabetes from "@/components/Diabetes"
import Disease from "@/components/Disease"
import Healthy from "@/components/Healthy"
import translate from "./components/translate.vue";
import BottomNav from "@/components/BottomNav"
import Report from "../../models/Report"
export default {
  components: { Summary, Physiology, Brain, Diabetes, Disease, Healthy, Organ, BottomNav, translate },
  data () {
    return {
      showSigns: false,
      active: 0,
      loading: true,
      navData: [
        { text: '健康概况', url: 'Organ', list: 'organ', show: true, },
        { text: '健康总评', url: 'Summary', list: 'summary', show: true, },
        { text: '生理系统风险', url: 'Physiology', list: 'physiology', show: true, },
        { text: '脑血管风险', url: 'Brain', list: 'brain', show: true, },
        { text: '糖尿病风险', url: 'Diabetes', list: 'Diabetes', show: true, },
        { text: '疾病风险', url: 'Disease', list: 'Disease', show: true, },
        { text: '健康管理建议', url: 'Healthy', list: 'healthy', show: true, },
        { text: '人体成分', url: 'translate', list: 'translate', show: true, }],
    }
  },
  computed: {
    id () {
      return this.$route.query.id || ''
    },
    user_no () {
      return this.$route.query.user_no || ''
    },
    showNav () {
      return this.$route.query.showNav || 0
    },
  },
  methods: {
    showDialog () {
      this.showSigns = true;
    },
    oylstatus (status) {
      let level;
      switch (status) {
        case 1:
          level = 5
          break;
        case 2:
          level = 4
          break;
        case 3:
          level = 3
          break;
        case 4:
          level = 2
          break;
        case 5:
          level = 1
          break;
      }
      return level
    }
  },
  created () {
    let params = {
      user_no: this.user_no,
      test_report_id: this.id
    }
    Report.getReports({ ...params }, (res, err) => {
      this.loading = true
      if (!err) {
        res.healthy.forEach(e => {
          e.btntxt = "查看建议";
          e.showCon = false
        });
        res.special[0].descArr = res.special[0].desc.split('\\r\\n');
        res.special[1].descArr = res.special[1].desc.split('\\r\\n')
        res.diabetes.descArr = res.diabetes.diabetes_desc.split('\\r\\n');
        res.brain.descArr = res.brain.brain_desc.split('\\r\\n');
        res.special[4].status = this.oylstatus(res.special[4].status)
        for (let key in res.physiology_system) {
          res.physiology_system[key].forEach(e => {
            e.showDetail = false;
            e.remakrs = e.remakrs ? e.remakrs.split('\\r\\n') : []
          })
        }
        console.log('adsfa', res.special[0])
        this.navData[0].data = res;
        this.navData[1].data = res.special;
        this.navData[2].data = {
          ...res.physiology,
          physiology_system: res.physiology_system
        };
        this.navData[3].data = res.brain;
        this.navData[4].data = res.diabetes;

        if (!res.disease) {
          this.navData.splice(5, 1);
          this.navData[5].data = {
            healthy: res.healthy,
            marks: res.marks
          }
          // this.navData[5].data = res.disease
        } else {
          this.navData[6].data = {
            healthy: res.healthy,
            marks: res.marks
          }
          this.navData[5].data = res.disease
        }
        if (res.is_show_survey === 1) {
          this.navData[0].text = '免疫风险等级'
          this.navData.splice(1, 5);
        }
        this.navData[7].data = res.rtcffx // 人体成分
        this.navData[7].data.forEach((item) => {
          if (item.name == '基础代谢' || item.name == '体重指数') {
            item.danwei = ""
          } else {
            item.danwei = "kg"
          }
        })
        console.log(this.navData[7].data)
        this.loading = false
      }
    })
  }
}
</script>
<style lang="scss" >
.layout {
  height: 100%;
}
.van-tabs--line .van-tabs__wrap {
  height: 80px !important;
  line-height: 80px;
  margin-bottom: 20px;
  width: 100%;
  font-size: 30px;
}
.van-tab__text {
  font-size: 30px;
}
.van-tabs__wrap--scrollable .van-tab {
  //    flex: 0 0 27% !important;
  font-size: 30px;
}
.vantabs {
  font-size: 30px;
  //    height: calc(100% - 100px);
  padding-bottom: 100px;
}
.PhysicalList {
  text-align: left;
}
</style>